<template>
    <div class="sms-input">
        <div class="header">
            <div class="left">
                <a-select v-model="channelId" :defaultValue="null">
                    <a-select-option :selected="true" value="null">👉Select SMS Provider...</a-select-option>
                    <a-select-option :key="channel._id" v-for="channel of smsChannels" :value="channel._id">
                        {{ channel.name }}
                    </a-select-option>
                </a-select>
                <i class="material-icons">perm_phone_msg</i>
            </div>
            <div class="middle">
                <a-select v-model="senderId" :defaultValue="null">
                    <a-select-option
                        v-for="sender of senders"
                        :value="sender.title"
                        :key="sender.uuid"
                    >
                        {{ sender.title }}
                    </a-select-option>
                    <a-select-option :value="''">
                        📞Select Sender
                    </a-select-option>
                </a-select>
                <i class="material-icons">badge</i>
            </div>
            <div class="right">
                <div class="phone-number-input">
                    <vue-country-code
                        class="col-3 country-code"
                        :enabledCountryCode="true"
                        @onSelect="onSelect($event)"
                        defaultCountry="TR"
                    />
                    <a-input
                        v-model="number"
                        :placeholder="$t('message.phone')"
                        autocomplete="off"
                        trim
                        type="text"
                        v-mask="'############'"
                    />
                </div>
            </div>
        </div>
        <div class="message-input">
            <TiptapEditor
                :placeholder="$t('message.writeYourMessage')"
                :show-attributes="false"
                :show-emoji="true"
                v-model="text"
                :preview-mode="false"
                :whatsapp-mode="false"
                :allowed-attributes="false"
                :max-character-count="160"
            />
        </div>
        <a-button type="primary" :disabled="!formIsValid()" class="sendSMSButton" @click="sendSMS">
            <div class="d-flex align-items-center justify-content-center gap-5">
                <i class="material-icons">send</i>
                {{ $t("message.sendSms") }}
            </div>
        </a-button>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import VueCountryCode from "vue-country-code";
import TiptapEditor from "../../../../Chatbot/pages/dashboard/common/TiptapEditor.vue";

export default Vue.extend({
    name: "SMSInputV2",
    components: { VueCountryCode, TiptapEditor },
    props: ["defaultPhoneNumber", "channel", "senders", "credit"],
    data() {
        return {
            text: "",
            channelId: null,
            senderId: "",
            number: this.excludeCountryCode(this.defaultPhoneNumber || ""),
        };
    },
    computed: {
        ...mapState({
            smsChannels: (state) => state.channel.channels.filter((x) => x.type === "sms-postacell"),
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
        }),
        /**
         *  text must be filled and less than 160 characters and more than 0
         *  channelId must be filled
         *  senderId must be filled
         *  number must be filled
         * @return {string|null}
         */
        formIsValid() {
            if (this.text.length < 1 || this.text.length > 160) {
                return false;
            }
            if (!this.channelId) {
                return false;
            }
            if (!this.senderId) {
                return false;
            }
            if (!this.number) {
                return false;
            }
            return true;
        },
        //exclude country code from any number
        excludeCountryCode(number) {
            return number.replace(this.countryCode, "");
        },
        sendSMS() {
            if(this.credit <= 0){
                this.$message.error("You don't have enough credit to send SMS");
                return;
            }
            this.$emit("sendSMS", {
                text: this.text,
                channelId: this.channelId,
                senderId: this.senderId,
                number: this.number,
            });

            this.$message.success("SMS sent successfully");
        },
    },
    mounted() {
        this.listChannels();
        this.channelId = this.channel || this.smsChannels[0]?._id;
    },
    watch: {
        smsChannels: {
            handler: function(val) {
                if (val.length > 0) {
                    this.channelId = this.channel || val[0]._id;
                }
            },
            deep: true,
        },
        text: {
            handler: function(val) {
                this.$emit("input", val);
            },
            deep: true,
        },
        defaultPhoneNumber: {
            handler: function(val) {
                this.number = this.excludeCountryCode(val || "");
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.sms-input {
    background: var(--color-bg-default);
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    padding: 20px;
    max-width: 400px;

    .header {
        padding: 10px 0;
        border-bottom: 1px solid var(--color-border-default);
        display: flex;
        flex-direction: column;
        gap: 10px;

        .left,
        .middle,
        .right {
            display: flex;
            gap: 10px;

            .ant-select {
                width: 100%;
                max-width: 300px;
            }

            i.material-icons {
                margin-right: 10px;
            }
        }

        .phone-number-input {
            display: flex;
            gap: 10px;
            align-items: center;

            .country-code {
                margin-right: 10px;
            }

            .ant-input {
                flex: 1;
                max-width: 300px;
            }
        }
    }

    .message-input {
        margin-top: 20px;
        min-height: 80px;
        border: 1px solid #c7d0d7;
        padding: 10px;
        border-radius: 5px;

        .ProseMirror {
            border: 1px solid var(--color-border-default);
            border-radius: 5px;
            padding: 10px;

            &.ProseMirror-focused {
                border-color: var(--color-primary);
            }
        }
    }

    .sendSMSButton {
        margin-top: 20px;
        height: 40px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
